<template>
  <div>
    <vl-map class="map joint-map" :style="mapStyle" ref="joint-index-map" :load-tiles-while-animating="true" :load-tiles-while-interacting="true" @click="clickCoordinate = $event.coordinate">
      <vl-view :max-zoom="15" :zoom="zoom" :rotation="rotation" :center="center" ref="view"></vl-view>
      <vl-layer-tile id="osm">
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>
      <vl-layer-vector>
        <vl-source-vector ref="vectorsource">
          <vl-feature @created="centerMap" v-for="j in joints" v-if="j.latitude < 9999" :key="j.joint_id" :id="j.joint_id" :properties="j">
            <vl-geom-point :coordinates="convertPos(j)"></vl-geom-point>
            <vl-style-box>
              <vl-style-icon src="../static/img/marker.png" :scale="1" :anchor="[0.5, 1]"></vl-style-icon>
            </vl-style-box>
          </vl-feature>
        </vl-source-vector>
      </vl-layer-vector>
      <vl-interaction-select v-if="enableOverlay" :features.sync="selectedFeatures">
        <vl-overlay v-for="feature in selectedFeatures" :key="feature.id" :auto-pan="true" :position="feature.geometry.coordinates" :offset="[10, 10]">
          <div class="card">
            <div class="card-body">
              {{ 'Machine-ID' | translate }} <strong>{{ feature.properties.name | sliceId }}</strong></br>
              {{ 'Joint-ID' | translate }} <strong>{{ feature.properties.joint_id }}</strong>
            </div>
          </div>
        </vl-overlay>
      </vl-interaction-select>
    </vl-map>
  </div>
</template>

<script>

import { convertCoordinates } from '../utils/coordinates'

export default {
  props: ['joints', 'zoom', 'mapStyle', 'enableOverlay'],
  data: function () {
    return {
      center: [0, 0],
      rotation: 0,
      clickCoordinate: undefined,
      selectedFeatures: []
    }
  },
  filters: {
    sliceId: function (val) {
      return val.slice(-3)
    }
  },
  methods: {
    centerMap: function () {
      if (this.joints.length === 1) {
        this.center = convertCoordinates(this.joints[0])
      } else {
        if (isFinite(this.$refs.vectorsource.$source.getExtent()[0])) {
          this.$refs.view.$view.fit(this.$refs.vectorsource.$source.getExtent())
        }
      }
    },
    convertPos: function (j) {
      return convertCoordinates(j)
    }
  }
}
</script>
<style>


</style>


// WEBPACK FOOTER //
// JointMap.vue?0c79319e